import React, { useState } from "react";

import { Button } from "antd";

export default function DataFieldEditCard(props) {
  const {
    isCommonDataField,
    prevTitleValue,
    prevDetailsValue,
    onSaveClick,
    onDeleteClick,
    onCancelClick,
  } = props;
  const [titleValue, setTitleValue] = useState(prevTitleValue || "");
  const [detailsValue, setDetailsValue] = useState(prevDetailsValue || "");

  const onTitleChange = (e) => {
    setTitleValue(e.target.value);
  };

  const onDetailsChange = (e) => {
    setDetailsValue(e.target.value);
  };

  return (
    <div className="DataFieldEditCardContainer">
      <div className="createFieldInputsContainer">
        <div className="spanContainer">
          <span className="inputTitleSpan"> Title* </span>
        </div>
        <input
          className="titleInput"
          value={titleValue}
          placeholder="Enter title"
          onChange={onTitleChange}
          disabled={!isCommonDataField}
        />

        <div className="spanContainer">
          <span className="inputTitleSpan"> Details </span>
        </div>
        <textarea
          className="detailsInput"
          value={detailsValue}
          placeholder="Enter details"
          onChange={onDetailsChange}
          disabled={isCommonDataField}
        />
      </div>
      <div className="dataFieldEditButtonContainer">
        {(isCommonDataField && !prevTitleValue)
          ? (
            <Button
              htmlType="button"
              type="default"
              onClick={onCancelClick}
            >
              Cancel
            </Button>
          )
          : (
            <Button
              htmlType="button"
              type="link"
              danger
              onClick={onDeleteClick}
            >
              Delete
            </Button>
          )}
        <Button
          htmlType="button"
          type="primary"
          disabled={titleValue === ""}
          onClick={() => onSaveClick(isCommonDataField ? titleValue : detailsValue)}
        >
          Save
        </Button>
      </div>
    </div>
  );
}
